import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  CONTAINER_TYPES_LOAD,
  containerTypesLoadAction,
  containerTypesLoadFailure,
  containerTypesLoadSuccess
} from './actions'

function* containerTypesLoadSaga(_: containerTypesLoadAction) {
  try {
    let containerTypes: string[] = []

    const response: { data: string[] } = yield call(() =>
      axios.get(`/referencedata/waste/container-types`)
    )

    containerTypes = response && response.data ? [...response.data] : []

    yield put(containerTypesLoadSuccess(containerTypes))
  } catch (error) {
    console.error(error)
    yield put(containerTypesLoadFailure(error))
  }
}

export function* watch() {
  yield all([takeLatest(CONTAINER_TYPES_LOAD, containerTypesLoadSaga)])
}
